import { store } from '@/store';
import { Snack } from '@/application/snackbar/types';

export function showSuccess(snack: Snack): void {
  store.dispatch('snackbar/showSuccess', snack);
}

export function showError(snack: Snack): void {
  store.dispatch('snackbar/showError', snack);
}

export function showErrorResponse(error: any): void {
  store.dispatch(
    'snackbar/showError',
    { message: error.response?.data.message || 'Es ist ein interner Fehler aufgetreten und die Entwickler wurden informiert.' }
  );
}
